import { Standard } from '@getvim/vim-connect';

export function getWritebackProceduresPayload(): Standard.WriteBacks.UpdateEncounter {
  return { plan: { procedureCodes: [{ code: '3210F' }] } };
}
